export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGGED_IN = 'LOGGED_IN';
export const LOG_OUT = 'LOG_OUT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const GET_CARS = 'GET_CARS';
export const SHOW_CAR = 'SHOW_CAR';
export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
export const GET_APPOINTMENTS = 'GET_APPOINTMENTS';
